export default {
  FETCH_ALL_TICKETS_SUCCESS: 'FETCH_ALL_TICKETS_SUCCESS',
  FETCH_ALL_TICKETS_LOADING: 'FETCH_ALL_TICKETS_LOADING',
  FETCH_ALL_TICKETS_REJECT: 'FETCH_ALL_TICKETS_REJECT',
  FETCH_ALL_TICKETS_FAILED: 'FETCH_ALL_TICKETS_FAILED',

  FETCH_TICKET_BY_ID_SUCCESS: 'FETCH_TICKET_BY_ID_SUCCESS',
  FETCH_TICKET_BY_ID_LOADING: 'FETCH_TICKET_BY_ID_LOADING',
  FETCH_TICKET_BY_ID_REJECT: 'FETCH_TICKET_BY_ID_REJECT',
  FETCH_TICKET_BY_ID_FAILED: 'FETCH_TICKET_BY_ID_FAILED',

  REPLY_TO_TICKET_SUCCESS: 'REPLY_TO_TICKET_SUCCESS',
  REPLY_TO_TICKET_LOADING: 'REPLY_TO_TICKET_LOADING',
  REPLY_TO_TICKET_REJECT: 'REPLY_TO_TICKET_REJECT',
  REPLY_TO_TICKET_FAILED: 'REPLY_TO_TICKET_FAILED',

  CLOSE_TICKET_SUCCESS: 'CLOSE_TICKET_SUCCESS',
  CLOSE_TICKET_LOADING: 'CLOSE_TICKET_LOADING',
  CLOSE_TICKET_REJECT: 'CLOSE_TICKET_REJECT',
  CLOSE_TICKET_FAILED: 'CLOSE_TICKET_FAILED',

  USER_TICKETS_SUCCESS: 'USER_TICKETS_SUCCESS',
  USER_TICKETS_LOADING: 'USER_TICKETS_LOADING',
  USER_TICKETS_REJECT: 'USER_TICKETS_REJECT',
  USER_TICKETS_FAILED: 'USER_TICKETS_FAILED',

}